import React, { Component } from 'react';
import '../styles/CreateUserForm.css';
import DropdownWidget from '../widgets/DropdownWidget';
import APIGenericRequest from '../api/APIGenericRequest';
import APIUserAccountRequest from '../api/APIUserAccountRequest';
import xButton from '../images/x.png';
import AlertMessage from '../widgets/AlertMessage';
import ActivityIndicator from '../widgets/ActivityIndicator';

class UpdateUserDetails extends Component
{
	constructor(props) {
		super(props);
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			employeeId: props.data.employeeBasicInfo.employee_id,
			firstName: props.data.employeeBasicInfo.first_name,
			middleName: props.data.employeeBasicInfo.middle_name,
			lastName: props.data.employeeBasicInfo.last_name,
			extName: props.data.employeeBasicInfo.extension_name,
			region: props.data.userDetails.region,
			province: props.data.userDetails.province,
			role: props.data.userDetails.role,
			contactNo: props.data.employeeBasicInfo.contact_no,
			username: props.data.userDetails.username,
			statusId: props.data.userDetails.user_status_id,
			status: props.data.userDetails.user_status,
			showConfirmMessage: false,
			pwPlaceholder: "****************"
		};
		this.getAllRegions = this.getAllRegions.bind(this);
		this.getAllProvincesByRegionId = this.getAllProvincesByRegionId.bind(this);
		this.getAllUserRoles = this.getAllUserRoles.bind(this);
		this.submitUserUpdate = this.submitUserUpdate.bind(this);
		this.disableFields = this.disableFields.bind(this);
		this.getAllProvincesByRegionId(props.data.userDetails.region_id);
		this.getAllUserRoles();
	}

	componentWillMount() {
		this.getAllRegions();
		this.getAllUserRoles();
		const ext = APIGenericRequest.getAllExtensionNames(this.state.accessToken);
		ext.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			for(const v of response.results.rows) {
				c.push({id: v.extension_id, name: v.name});
			}
			c.push({id: 0, name: "N/A"});
			this.setState({extNames: c});
		});
	}

	getAllRegions() {
		const region = APIGenericRequest.getAllRegions(this.state.accessToken);
		region.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			for(const v of response.results.rows) {
				c.push({id: v.region_id, name: v.name.split("[")[0]});
			}
			c.push({id: 0, name: "-- SELECT REGION --"});
			this.setState({regions: c});
		});
	}

	getAllProvincesByRegionId(id) {
		const province = APIGenericRequest.getAllProvincesByRegionId(this.state.accessToken, id);
		province.then((response) => {
			if(response.status === "FAILED") {
				return;
			}
			const c = [];
			for(const v of response.results.rows) {
				c.push({id: v.province_id, name: v.name});
			}
			c.push({id: 0, name: "-- SELECT PROVINCE --"});
			this.setState({provinces: c, province: "PROVINCE"});
		});
	}

	getAllUserRoles() {
		this.setState({showActivityIndicator: true});
		const role = APIUserAccountRequest.getAllUserRoles(this.state.accessToken);
		role.then((response) => {
			if(response.status === "FAILED") {
			this.setState({showActivityIndicator: false});
				return;
			}
			const c = [];
			for(const v of response.results.rows) {
				c.push({id: v.role_id, name: v.name});
			}
			this.setState({roles: c, showActivityIndicator: false});
		});
	}

	submitUserUpdate(data, id, resetPW) {
		const sur = APIUserAccountRequest.editUserRegistration(this.state.accessToken, data, id);
		sur.then((response) => {
			if(resetPW) {
				if(response.status === "FAILED") {
					this.setState({
						showWarningMessage: true,
						showConfirmMessage: false,
						aMessage: "Reset password " + response.status + ": " + response.errors[1].userDetails,
						showActivityIndicator: false
					});
					return
				}
				this.setState({
					showInfoMessage: true,
					showConfirmMessage: false,
					aMessage: "Reset password " + response.status,
					showActivityIndicator: false
				});
			}
			else {
				this.setState({showActivityIndicator: false});
				const name = data.employeeBasicInfo.first_name + " " +
					data.employeeBasicInfo.middle_name + " " +
					data.employeeBasicInfo.last_name;
				this.props.onSignal(name, response.status);
			}
		});
	}

	disableFields(v) {
		const fields = document.querySelectorAll('.cu-body *:not(button):not(#cu-username)');
		for(const f of fields) {
			f.disabled = v;
		}
		this.setState({disabled: v,  pwPlaceholder: "****************"});
		const pw = document.getElementById('cu-password');
		pw.disabled = !v
		pw.value = ""
		const btn = document.getElementById('uup-reset');
		
		if(v) {
			btn.innerHTML = "SUBMIT";
		}
		else {
			btn.innerHTML = "RESET";
		} 
	}

	render() {
		const view = <div className="update-user-details">
			<div className="cu-header">
				<div>UPDATE USER DETAILS</div>
				<img src={xButton} className="close-icon" alt="ADD" onClick={() => {
					this.props.onSignal();
				}} />
			</div>
			<div className="cu-body">
				<div className="cu-fullname">
					<div>Full Name</div>
					<input type="text" id="cu-firstname" value={this.state.firstName} 
						onChange={e => this.setState({firstName: e.target.value.toUpperCase()}) } />
					<input type="text" id="cu-middlename" value={this.state.middleName}
						onChange={e => this.setState({middleName: e.target.value.toUpperCase()}) } />
					<div>
						<input type="text" id="cu-lastname" value={this.state.lastName}
						onChange={e => this.setState({lastName: e.target.value.toUpperCase()}) } />
						<DropdownWidget list={this.state.extNames} placeholder={this.state.extName}
						onItemSelected={(id, val) => {
							this.setState({extName: val})
						}} cStyle={{"width": "60px"}} />
					</div>
				</div>
				<div className="cu-address">
					<div>Office Address</div>
					<DropdownWidget list={this.state.regions} placeholder={this.state.region} disabled={this.state.disabled}
						cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
							this.getAllProvincesByRegionId(id);
							this.setState({regionId: id});
						}} />
					<DropdownWidget list={this.state.provinces} placeholder={this.props.data.userDetails.province} disabled={this.state.disabled}
						cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
							this.setState({provinceId: id});
						}} />
				</div>
				<div className="cu-role">
					<div>Role</div>
					<DropdownWidget list={this.state.roles} placeholder={this.state.role} disabled={this.state.disabled}
						cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
							this.setState({roleId: id});
						}} />
				</div>
				<div className="uud-status">
					<div className="cu-status">
						<div>Status</div>
						<DropdownWidget list={status} placeholder={this.state.status} disabled={this.state.disabled}
							cStyle={{"width": "100%"}} onItemSelected={(id, val) => {
								this.setState({statusId: id});
							}} />
					</div>
					<div className="cu-contact">
						<div>Contact No.</div>
						<input type="text" value={this.state.contactNo} onChange={(e) => {
							const checker = /^[0-9]+$/;
							const isValid = checker.test(e.target.value);
							if(isValid) {
								this.setState({contactNo: e.target.value});
							}
							else {
								if(isNaN(parseInt(e.target.value))) {
									e.target.value = "";
									this.setState({contactNo: ''});
								}
								else {
									e.target.value = parseInt(e.target.value);
								}
							}
						}} />
					</div>
				</div>
				<div className="cu-login">
					<div>Login Credentials</div>
					<input type="text" id="cu-username" value={this.state.username} onChange={e => {
						const checker = /^[A-Za-z0-9@._-]+$/;
						const isValid = checker.test(e.target.value);
						if(isValid) {
							this.setState({username: e.target.value});
						}
						else {
							this.setState({username: null});
						}
					}} style={{'text-transform': 'none'}} disabled={true} />
					<div id="uud-password">
						<input type="text" id="cu-password" value={this.state.pwPlaceholder}
							onChange={e => this.setState({password: e.target.value, pwPlaceholder: e.target.value}) }
							style={{'text-transform': 'none'}} disabled={true} />
						<button className="green-two" id="uup-reset" onClick={(e) => {
							if(e.target.innerHTML === "SUBMIT") {
								this.setState({
									showConfirmMessage: true,
									aMessage: "Are you sure you want to change password?"
								});
							}
							else {
								this.disableFields(true);
							}
						}}>RESET</button>
					</div>
				</div>
				<button className="green-two" onClick={() => {
					this.setState({showActivityIndicator: true});
					const data = {
						"employeeBasicInfo": {
							"last_name": this.state.lastName,
							"first_name": this.state.firstName,
							"extension_name": this.state.extName,
							"middle_name": this.state.middleName,
							"contact_no": this.state.contactNo
						},
						"userDetails": {
							"role_id": this.state.roleId,
							"region_id": this.state.regionId,
							"province_id": this.state.provinceId,
							"user_status_id": this.state.statusId
						}
					};
					this.submitUserUpdate(data, this.state.employeeId, false);
				}}>SUBMIT</button>
			</div>
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => {
					this.setState({showWarningMessage: false});
				}} />}
			{this.state.showInfoMessage == true && <AlertMessage type="information" text={this.state.aMessage}
				onClick={() => {
					if(this.state.closeForm) {
						this.props.onSignal();
						return;
					}
					this.setState({showInfoMessage: false});
					this.disableFields(false);
				}} />}
			{this.state.showConfirmMessage == true && <AlertMessage type="confirmation" text={this.state.aMessage}
				onClick={(e) => {
					if(e.target.innerHTML === "NO") {
						this.disableFields(false);
						this.setState({showConfirmMessage: false});
					}
					else {
						this.setState({showActivityIndicator: true});
						const data = {"userDetails": {"password": this.state.password}};
						this.submitUserUpdate(data, this.state.employeeId, true);
					}
				}} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>;
		return(view);
	}
}

const status = [
	{id: 1, name: "ACTIVE"},
	{id: 2, name: "LOCKED"},
	{id: 3, name: "DISABLED"}
];

export default UpdateUserDetails;
